
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("f8pkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5728371334eb545$export$2e2bcd8739ae039);

var $g4gW0 = parcelRequire("g4gW0");

var $a92Ax = parcelRequire("a92Ax");

var $eP48i = parcelRequire("eP48i");

var $erVR3 = parcelRequire("erVR3");
class $a5728371334eb545$export$2e2bcd8739ae039 {
    rootEventBus = (0, $erVR3.rootEventBus);
    EnumRootEventBus = (0, $erVR3.EnumRootEventBus);
    Angles = [];
    constructor(anglePropsArr, followCircleAnim = true){
        this.Angles = anglePropsArr.map((angleProps, aI)=>new (0, $g4gW0.default)(`a${aI + 1}`, angleProps.angleColors, angleProps.smallDistanceOffset, angleProps.addCon, angleProps.addSmallDis));
        if (followCircleAnim) {
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
        }
    }
    setAllVisible = (v)=>this.Angles.forEach((angle)=>angle.setVisible(v));
    getAngles = ()=>this.Angles;
    drawAngle(angle, p, degree, clockwise) {
        const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
        const smllDistance = Math.floor(Math.min((0, $eP48i.default)(p.curr, p.prev), (0, $eP48i.default)(p.curr, p.next)));
        angle.smallDistance = smllDistance;
        angle.draw(p.curr, startRadian, endRadian, degree, !clockwise);
        angle.x = p.curr.x;
        angle.y = p.curr.y;
        angle.rotation = 0;
    }
}

});
parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});


parcelRegister("jZEcn", function(module, exports) {

$parcel$export(module.exports, "generateAngles", () => $83c21d34517267ce$export$adec80d12bc0398e);

var $a92Ax = parcelRequire("a92Ax");

var $cwj7p = parcelRequire("cwj7p");
function $83c21d34517267ce$export$adec80d12bc0398e(p, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
    const degree = (0, $cwj7p.default)({
        startRadian: startRadian,
        endRadian: endRadian
    }, clockwise, false);
    return {
        startRadian: startRadian,
        endRadian: endRadian,
        degree: degree
    };
}

});
parcelRegister("cwj7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6eb8af25d6ad3b0$export$2e2bcd8739ae039);

var $74Gga = parcelRequire("74Gga");
function $a6eb8af25d6ad3b0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $74Gga.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});
parcelRegister("74Gga", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b402dd6b18638d$export$2e2bcd8739ae039);
function $e6b402dd6b18638d$export$2e2bcd8739ae039(radian) {
    return Math.round(radian * (180 / Math.PI));
}

});



parcelRegister("eitLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $295d8ae516c805d1$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $gcphA = parcelRequire("gcphA");
class $295d8ae516c805d1$export$2e2bcd8739ae039 {
    CheckboxRenderer;
    isChecked = false;
    checkBoxLabel;
    handleFunc;
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        this.CheckboxRenderer = new (0, $gcphA.default)(color, label, useCustomLayer);
        Object.assign(this.CheckboxRenderer, coord);
        this.handleFunc = handleFunc;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToCon = (con)=>con.addChild(this.CheckboxRenderer);
    setScale = (v)=>this.CheckboxRenderer.con.scale.set(v);
    setVisible = (v)=>this.CheckboxRenderer.visible = v;
    addInteractivity() {
        const handleUpFunc = ()=>this.handleCheckbox();
        (0, $16Wgx.default)(this.CheckboxRenderer, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
    setChecked(v) {
        this.isChecked = v;
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
}

});
parcelRegister("gcphA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f182ab57cf75ac$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $c6f182ab57cf75ac$export$2e2bcd8739ae039 extends $iuB9z.Container {
    color;
    checkboxLabel;
    Layers;
    con;
    checkedSquare;
    defaultColor;
    constructor(color, checkboxLabel, useCustomLayer = false){
        super(), this.color = color, this.checkboxLabel = checkboxLabel, this.Layers = (0, $9ec1t.default).getInstance(), this.con = this.addChild(new $iuB9z.Container()), this.checkedSquare = this.con.addChild(new $iuB9z.Graphics()), this.defaultColor = 0xFFFFFF, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.drawCheckbox(false);
        this.addLabel();
        !useCustomLayer && this.addToLayer();
    }
    addToLayer;
    drawCheckbox(isColored) {
        const fillColor = isColored ? this.color : this.defaultColor;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addLabel() {
        const text = new $iuB9z.Text({
            text: this.checkboxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.con.addChild(text);
    }
}

});


parcelRegister("gix9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4713a546dfab5e00$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $krubk = parcelRequire("krubk");

var $erVR3 = parcelRequire("erVR3");
class $4713a546dfab5e00$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    Switcher;
    Header;
    coords;
    handleFunc;
    constructor({ header: header, coords: coords, handleFunc: handleFunc }){
        super();
        this.coords = coords;
        this.handleFunc = handleFunc;
        this.addHeader(header);
        this.addCoord();
        this.addSwitcher();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible = (v)=>this.visible = v;
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addCoord() {
        const dim = this.Game.getDim();
        let coord = this.coords.horizontal;
        if (dim.WIDTH < dim.HEIGHT) coord = {
            x: dim.WIDTH / 2 + this.coords.vertical.x,
            y: dim.HEIGHT / 2 + this.coords.vertical.y
        };
        Object.assign(this, coord);
    }
    addHeader(header) {
        this.Header = new $iuB9z.Text({
            text: header
        });
        this.Header.anchor.set(.5);
        this.Header.x = 0;
        this.Header.y = -32;
        this.addChild(this.Header);
    }
    addSwitcher() {
        const dim = this.Game.getDim();
        this.Switcher = new (0, $krubk.default)(0x55E39F, this.handleFunc, true);
        this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
        this.Switcher.x = 0;
        this.Switcher.y = 0;
        this.addChild(this.Switcher);
    }
    getActivationStatus = ()=>this.Switcher.getActive();
    setActivation(v) {
        const isActive = this.Switcher.getActive();
        if (v && isActive) this.Switcher.handleSwitcher(!isActive);
    }
}

});
parcelRegister("krubk", function(module, exports) {

$parcel$export(module.exports, "default", () => $621ca3294779f8aa$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $8xLbP = parcelRequire("8xLbP");

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
const $621ca3294779f8aa$var$BUTTON_X = 10;
class $621ca3294779f8aa$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    isActive = false;
    greenBg;
    grayBg;
    button;
    handleSwitch;
    constructor(color, handleSwitch, isAddCon = false){
        super();
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).closeSwitcher, ()=>this.handleSwitcherOff());
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    getActive = ()=>this.isActive;
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $iuB9z.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitcher(isActive) {
        this.isActive = isActive;
        this.handleSwitch(this.isActive);
        new (0, $8xLbP.default)(this);
    }
    handleSwitcherOff() {
        if (!this.isActive) return;
        this.handleSwitcher(false);
    }
    addInteractivity() {
        const handleDownFunc = ()=>this.handleSwitcher(!this.isActive);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $621ca3294779f8aa$var$BUTTON_X * v : 2 * $621ca3294779f8aa$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $iuB9z.Graphics().circle(-$621ca3294779f8aa$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("8xLbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $074e271eb87a9bab$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $074e271eb87a9bab$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $6m47o.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});



parcelRegister("jtirH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c5a2df4ae2bc79$export$2e2bcd8739ae039);
function $34c5a2df4ae2bc79$export$2e2bcd8739ae039(cCoord, cCircumPoint, aSide1, aSide2) {
    let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
    if (angle < 0) angle += 2 * Math.PI;
    let start = aSide1;
    let end = aSide2;
    if (start < 0) start += 2 * Math.PI;
    if (end < 0) end += 2 * Math.PI;
    if (start <= end) return angle >= start && angle <= end;
    else return angle >= start || angle <= end;
}

});

parcelRegister("jISXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66faaaf67ef5cb50$export$2e2bcd8739ae039);
function $66faaaf67ef5cb50$export$2e2bcd8739ae039(dim, CENTER_OF_CIRCLE) {
    if (dim.WIDTH > dim.HEIGHT) return CENTER_OF_CIRCLE;
    return {
        x: dim.WIDTH / 2,
        y: dim.HEIGHT / 2
    };
}

});

parcelRegister("9tAmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e632069963336c$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $erVR3 = parcelRequire("erVR3");

var $d0yDD = parcelRequire("d0yDD");

var $cdlGy = parcelRequire("cdlGy");

var $jYh5T = parcelRequire("jYh5T");
class $13e632069963336c$export$2e2bcd8739ae039 {
    Layers = (0, $9ec1t.default).getInstance();
    isShownSegment = false;
    line = new (0, $d0yDD.default)({
        color: 0xFF0000,
        width: 6
    });
    segments;
    cCoord;
    constructor(cCoord){
        this.cCoord = cCoord;
        this.addSegments();
    }
    handleSegmentVisible(v) {
        this.isShownSegment = v;
        this.segmentVisibleWithAnimated(v);
    }
    segmentVisibleWithAnimated(v) {
        const sOpacity = v ? 0 : 1;
        const tOpacity = v ? 1 : 0;
        const duration = 100;
        const elms = [
            this.line,
            ...this.segments
        ];
        elms.forEach((elm)=>elm.alpha = sOpacity);
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).drawElements);
        elms.forEach((elm)=>new (0, $jYh5T.default)(elm, sOpacity, tOpacity, duration, ()=>!v ? elm.clear() : ""));
    }
    addSegments() {
        this.segments = Array(2).fill("").map((_)=>new $iuB9z.Graphics());
        this.Layers.BottomUnder.addChild(...this.segments);
    }
    draw(radius, radians, [sCoord, eCoord], clockwise) {
        if (!this.isShownSegment) return;
        this.line.draw(sCoord, eCoord);
        (0, $cdlGy.default)(this.segments, this.cCoord, radius, radians, clockwise);
    }
    clearAll() {
        this.segments.forEach((s)=>s.clear());
        this.line.clear();
    }
}

});
parcelRegister("cdlGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcb2dbd26932bc43$export$2e2bcd8739ae039);

var $hCdov = parcelRequire("hCdov");
function $fcb2dbd26932bc43$export$2e2bcd8739ae039(segments, cCoord, radius, radians, clockwise) {
    const points = (0, $hCdov.default)(cCoord, radians, radius);
    const _rs = [
        [
            radians[0],
            radians[1]
        ],
        [
            radians[1],
            radians[0]
        ]
    ];
    const rs = clockwise ? _rs : _rs.reverse();
    const colors = [
        0xFDEEE4,
        0xDDF9FF
    ];
    segments.forEach((segment, sI)=>{
        segment.clear().moveTo(points[0].x, points[0].y).lineTo(points[1].x, points[1].y).arc(cCoord.x, cCoord.y, radius, rs[sI][0], rs[sI][1]).fill(colors[sI]);
    });
}

});

parcelRegister("jYh5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $016f335fbdc70656$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $016f335fbdc70656$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(elm, sOpacity, tOpacity, duration, onComp){
        super();
        const opacity = {
            alpha: sOpacity
        };
        new (0, $6m47o.default).Tween({
            ...opacity
        }).to({
            alpha: tOpacity
        }, duration).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((o)=>elm.alpha = o.alpha).onComplete(()=>onComp()).start();
    }
}

});


parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");
var $7ca2578c40a9e88e$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["moveAllPoints"] = "MOVE_ALL_POINTS";
    EnumEventBus["moveCircumPoints"] = "MOVE_CIRCUMFERENCE_POINTS";
    EnumEventBus["setPointChecklist"] = "SET_POINT_CHECK_LIST";
    EnumEventBus["setRefPoints"] = "SET_REF_POINTS";
    EnumEventBus["catMode"] = "CAT_MODE";
    EnumEventBus["showSecondAngles"] = "SHOW_SECOND_ANGLES";
    EnumEventBus["segmentMode"] = "SEGMENT_MODE";
    return EnumEventBus;
}({});
const $7ca2578c40a9e88e$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();



var $fGH3X = parcelRequire("fGH3X");

var $iiVV4 = parcelRequire("iiVV4");

var $5ehzb = parcelRequire("5ehzb");
const $14419ed3de2cf7a8$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $14419ed3de2cf7a8$export$301500ed3a742f63 = [
    0x21D4FE,
    0x0195B8
];
const $14419ed3de2cf7a8$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $14419ed3de2cf7a8$export$ca8f2c484d507a5d = 200;
const $14419ed3de2cf7a8$export$95c476c8e1b0007 = [
    -Math.PI / 1.35,
    -Math.PI / 4,
    Math.PI / 4.8,
    Math.PI / 1.4
];
const $14419ed3de2cf7a8$export$bdea539c223eec51 = [
    $14419ed3de2cf7a8$export$301500ed3a742f63[1],
    0x000000,
    $14419ed3de2cf7a8$export$7a003cdef7722780[1],
    0x000000
];
const $14419ed3de2cf7a8$export$61fbb6169309251f = "x";
const $14419ed3de2cf7a8$export$186dbbe504e85fe1 = [
    {
        x: 70,
        y: 800
    },
    {
        x: 440,
        y: 800
    }
];
const $14419ed3de2cf7a8$export$75f2cc8245aafe09 = [
    {
        x: -260,
        y: 400
    },
    {
        x: 60,
        y: 400
    }
];
const $14419ed3de2cf7a8$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $14419ed3de2cf7a8$export$6e9eb14a7bc3c2c7 = "/circle-theorem-4/cat.png";
const $14419ed3de2cf7a8$export$2e51dc0dfab2d766 = "circle-theorem-4";



class $30d9f05454be34d0$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    pointCheckList = [
        false,
        false
    ];
    constructor(cCoord){
        super(cCoord, (0, $14419ed3de2cf7a8$export$ca8f2c484d507a5d), (0, $14419ed3de2cf7a8$export$95c476c8e1b0007));
        this.setCoord();
        this.draw();
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).setPointChecklist, (l)=>this.pointCheckList = l);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).moveCircumPoints, (v)=>this.moveCircumPoints(v));
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).moveAllPoints, (v)=>this.moveAllPoints(v));
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).setRefPoints, ()=>this.pointRefRadians = [
                ...this.pointRadians
            ]);
    }
    moveAllPoints(v) {
        const points = this.getRedPoints();
        const pointInfoArr = this.getRefRadians().map((ref, refI)=>({
                pTag: points[refI].tag,
                radian: ref + v / 100 * (Math.PI / 3)
            }));
        this.setRadian(pointInfoArr, true);
    }
    moveCircumPoints(v) {
        const points = this.getRedPoints();
        const generateOffsetRadian = (v)=>Math.PI / 300 * v;
        const pointInfoArr = this.pointCheckList.map((e, eI)=>this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0)).map((r, rI)=>({
                pTag: points[rI].tag,
                radian: r
            }));
        this.setRadian(pointInfoArr, true);
    }
}



var $9m5D8 = parcelRequire("9m5D8");

class $126c660212978562$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B",
            "C",
            "D"
        ]);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).catMode, (v)=>setTimeout(()=>this.setAllVisible(!v), v ? 0 : 300));
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");
class $9d8e089194180c48$export$2e2bcd8739ae039 {
    lines = Array(4).fill(null).map((_)=>new (0, $d0yDD.default)());
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    setAllVisible = (status)=>[
            ...this.lines
        ].forEach((l)=>l.visible = status);
    clearAll = ()=>this.lines.forEach((l)=>l.clear());
    draw(points) {
        this.lines[0].draw(points[0], points[2]);
        this.lines[1].draw(points[0], points[3]);
        this.lines[2].draw(points[1], points[2]);
        this.lines[3].draw(points[1], points[3]);
    }
}




var $f8pkD = parcelRequire("f8pkD");

var $jZEcn = parcelRequire("jZEcn");

const $0749e5568c1feeec$var$pAC = (0, $14419ed3de2cf7a8$export$7a003cdef7722780);
const $0749e5568c1feeec$var$bAC = (0, $14419ed3de2cf7a8$export$301500ed3a742f63);
const $0749e5568c1feeec$var$anglePropsArr = Array(4).fill(null).map((_, i)=>({
        angleColors: {
            color: i > 1 ? $0749e5568c1feeec$var$bAC[0] : $0749e5568c1feeec$var$pAC[0],
            textColor: i > 1 ? $0749e5568c1feeec$var$bAC[1] : $0749e5568c1feeec$var$pAC[1]
        },
        smallDistanceOffset: 100
    }));
class $0749e5568c1feeec$export$2e2bcd8739ae039 extends (0, $f8pkD.default) {
    constructor(){
        super($0749e5568c1feeec$var$anglePropsArr);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).catMode, (v)=>setTimeout(()=>this.setAllVisible(!v), v ? 0 : 300));
    }
    draw(points, clockwises, isShownSecondAngles) {
        Array(2).fill(null).forEach((_, aI)=>{
            const P = {
                curr: points[aI],
                prev: points[2],
                next: points[3]
            };
            const degree = (0, $jZEcn.generateAngles)(P, !clockwises[aI]).degree;
            this.drawAngle(this.Angles[aI], P, degree, clockwises[aI]);
        });
        this.Angles[2].setVisible(isShownSecondAngles);
        this.Angles[3].setVisible(isShownSecondAngles);
        if (isShownSecondAngles) {
            const cw = [
                clockwises[1],
                clockwises[0]
            ];
            Array(2).fill(null).forEach((_, aI)=>{
                const P = {
                    curr: points[aI + 2],
                    prev: points[1],
                    next: points[0]
                };
                const degree = (0, $jZEcn.generateAngles)(P, cw[aI]).degree;
                this.drawAngle(this.Angles[aI + 2], P, degree, !cw[aI]);
            });
        }
    }
}



var $eitLW = parcelRequire("eitLW");

var $b2sIL = parcelRequire("b2sIL");


const $ee97e2cbc2d5cb1e$var$SliderGen = [
    {
        head: "rotate circle",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).emit((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).moveAllPoints, v - 100)
    },
    {
        head: "move circumferences",
        subHead: "(select which one to use)",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        onUpdate: (v)=>(0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).emit((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).moveCircumPoints, v - 100)
    }
];
const $ee97e2cbc2d5cb1e$var$pointName = [
    "Point A",
    "Point B"
];
class $ee97e2cbc2d5cb1e$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    pointCheckboxs = [];
    pointChecklist = Array(2).fill(false);
    constructor(){
        super($ee97e2cbc2d5cb1e$var$SliderGen, (0, $14419ed3de2cf7a8$export$186dbbe504e85fe1), (0, $14419ed3de2cf7a8$export$75f2cc8245aafe09));
        this.addCheckBoxs();
    }
    handleCheckbox(index, v) {
        this.pointChecklist[index] = v;
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).emit((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).setPointChecklist, this.pointChecklist);
    }
    addCheckBoxs() {
        const coords = $ee97e2cbc2d5cb1e$var$getPointCheckboxCoords(this.dim);
        this.pointCheckboxs = Array(2).fill((0, $14419ed3de2cf7a8$export$7a003cdef7722780)[0]).map((e, eI)=>new (0, $eitLW.default)(coords[eI], $ee97e2cbc2d5cb1e$var$pointName[eI], e, false, (label, v)=>this.handleCheckbox(eI, v)));
        this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxs.forEach((cbox)=>cbox.setScale(.8));
    }
}
function $ee97e2cbc2d5cb1e$var$getPointCheckboxCoords(dim) {
    const coordHorizontal = [
        {
            x: 765,
            y: 775
        },
        {
            x: 765,
            y: 825
        }
    ];
    const getCoordHorizontal = (eI)=>coordHorizontal[eI];
    const getCoordVertical = (eI)=>({
            x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
            y: dim.HEIGHT / 2 + 520 + (eI % 2 == 1 ? 40 : 0)
        });
    return Array(2).fill(null).map((e, eI)=>dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI == 1 ? eI + 1 : eI));
}



var $erVR3 = parcelRequire("erVR3");


var $iD90R = parcelRequire("iD90R");


var $darcK = parcelRequire("darcK");
async function $c1a04f718feb77c2$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, PointTagManager: PointTagManager, AngleManager: AngleManager, cCoord: cCoord } = context;
    const centerPoint = PointManager.getPoints()[0];
    const pointsCoord = PointManager.getRedPointsCoord();
    const RedPoints = PointManager.getRedPoints();
    const initialRadian = PointManager.getInitialRadians();
    const radians = PointManager.getRadians();
    const angles = AngleManager.getAngles();
    AngleManager.draw(pointsCoord, [
        true,
        true
    ], false);
    circle.setRadians([
        (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[0],
        (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[0]
    ]);
    circle.setColors([
        0x000000,
        0x000000,
        (0, $14419ed3de2cf7a8$export$bdea539c223eec51)[2],
        0x000000
    ]);
    (0, $iD90R.drawPointsAnim)([
        centerPoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[0] + Math.PI * 2, 0, true, cCoord);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[3], pointsCoord[0], pointsCoord[2]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[2], pointsCoord[2], pointsCoord[1]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[1], pointsCoord[1], pointsCoord[3]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[0], pointsCoord[3], pointsCoord[0]);
    circle.setRadians([
        (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[0],
        (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[1],
        (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[2],
        (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[2]
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $14419ed3de2cf7a8$export$95c476c8e1b0007)[3], 3, false, cCoord);
    (0, $iD90R.drawAngleAnim)(angles[0], (0, $14419ed3de2cf7a8$export$61fbb6169309251f));
    await (0, $iD90R.drawAngleAnim)(angles[1], (0, $14419ed3de2cf7a8$export$61fbb6169309251f));
    PointTagManager.setAllVisible(true);
    await (0, $iD90R.rotateCircleAnim)((v)=>{
        const arr = Array(4).fill(v).map((v, vI)=>({
                pTag: RedPoints[vI].tag,
                radian: (0, $darcK.normalizeRadian)(initialRadian[vI] + v)
            }));
        PointManager.setRadian(arr);
    });
    const pointAnimArr = [
        [
            -Math.PI / 1.5,
            -Math.PI / 3,
            -Math.PI / 8,
            -Math.PI / 1.1
        ],
        [
            -Math.PI / 1.1,
            -Math.PI / 8,
            Math.PI / 7,
            Math.PI / 1.3
        ],
        PointManager.getInitialRadians()
    ];
    for(let index = 0; index < pointAnimArr.length; index++){
        const arr = pointAnimArr[index];
        await (0, $iD90R.moveAllPointAnim)(radians, arr, (radian, index)=>PointManager.setRadian([
                {
                    pTag: RedPoints[index].tag,
                    radian: radian
                }
            ]));
    }
    await (0, $iD90R.drawPointsAnim)(RedPoints);
    onComp();
}



var $e8wW1 = parcelRequire("e8wW1");

class $676471eec30405b5$export$2e2bcd8739ae039 {
    PointManager;
    PointTagManager;
    AngleManager;
    LineManager;
    circle;
    cCoord;
    isCatModeActive;
    isScndModeActive;
    isSegmentModeActive;
    constructor(PointManager, PointTagManager, AngleManager, LineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.PointTagManager = PointTagManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.isCatModeActive = false;
        this.isScndModeActive = false;
        this.isSegmentModeActive = false;
        this.getDelayForStartAnim = ()=>this.isCatModeActive || this.isScndModeActive ? 1000 : this.isSegmentModeActive ? 150 : 0;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $14419ed3de2cf7a8$export$840ec2322406bfdd), ()=>this.runAnimations(), ()=>this.getDelayForStartAnim());
        this.completedCircleAnim = ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        };
        this.addCircAnimBut();
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).catMode, (v)=>this.isCatModeActive = v);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).showSecondAngles, (v)=>this.isScndModeActive = v);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).segmentMode, (v)=>this.isSegmentModeActive = v);
    }
    getDelayForStartAnim;
    addCircAnimBut;
    completedCircleAnim;
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            circle: this.circle,
            LineManager: this.LineManager,
            PointManager: this.PointManager,
            PointTagManager: this.PointTagManager,
            AngleManager: this.AngleManager,
            cCoord: this.cCoord
        };
        (0, $c1a04f718feb77c2$export$2721aded6352b5ea)(context, ()=>this.completedCircleAnim());
    }
}



var $3DpJv = parcelRequire("3DpJv");

var $iuB9z = parcelRequire("iuB9z");


var $9ec1t = parcelRequire("9ec1t");

var $7vBln = parcelRequire("7vBln");


var $2h5MD = parcelRequire("2h5MD");

var $kSVlj = parcelRequire("kSVlj");

var $hCdov = parcelRequire("hCdov");

var $3ANoO = parcelRequire("3ANoO");
class $507e03cfb66f43c9$export$2e2bcd8739ae039 extends $iuB9z.Container {
    cCoord;
    Layers;
    earLeft;
    earRight;
    noise;
    constructor(cCoord){
        super(), this.cCoord = cCoord, this.Layers = (0, $9ec1t.default).getInstance(), this.addToLayer = ()=>this.Layers.Middle.addChild(this);
        this.addSprites();
        this.addToLayer();
        this.setVisible(false, true);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).catMode, (v)=>this.setVisible(v));
    }
    addToLayer;
    setVisible(v, noAnimation = false) {
        const onUpdate = (elm, v)=>elm.scale.set(v);
        [
            this.earLeft,
            this.earRight,
            this.noise
        ].forEach((catPart)=>{
            if (noAnimation) {
                catPart.visible = v;
                return;
            }
            catPart.scale.set(v ? .4 : .8);
            v && (catPart.visible = v);
            v ? new (0, $kSVlj.default)(.4, .8, (v)=>onUpdate(catPart, v)) : new (0, $kSVlj.default)(.8, .4, (v)=>onUpdate(catPart, v), ()=>catPart.visible = v);
        });
    }
    addSprites() {
        const texture = (0, $7vBln.default).getTexture((0, $14419ed3de2cf7a8$export$6e9eb14a7bc3c2c7)); //258pxx195px
        this.earLeft = this.addSprite(texture, {
            x: 0,
            y: 0,
            w: 110,
            h: 100
        });
        this.earRight = this.addSprite(texture, {
            x: 143,
            y: 0,
            w: 110,
            h: 100
        });
        this.noise = this.addSprite(texture, {
            x: 0,
            y: 125,
            w: 258,
            h: 70
        });
    }
    updateCoord(radians) {
        const offset = [
            -Math.PI / 2 * .85,
            -Math.PI / 2 * 1.15
        ];
        const pointsCoord = (0, $hCdov.default)(this.cCoord, radians, (0, $3ANoO.INITIAL_CIRCLE_RADIUS) + 25);
        [
            this.earLeft,
            this.earRight
        ].forEach((e, eI)=>{
            const c = pointsCoord[eI];
            Object.assign(e, c);
            e.rotation = (0, $2h5MD.default)(c, this.cCoord) + offset[eI];
        });
        const deltaPoint = {
            x: (pointsCoord[0].x + pointsCoord[1].x) / 2,
            y: (pointsCoord[0].y + pointsCoord[1].y) / 2
        };
        Object.assign(this.noise, this.cCoord);
        this.noise.rotation = (0, $2h5MD.default)(deltaPoint, this.cCoord) - Math.PI / 2;
    }
    addSprite(source, bounds) {
        const frame = new $iuB9z.Rectangle(bounds.x, bounds.y, bounds.w, bounds.h);
        const texture = new $iuB9z.Texture({
            source: source,
            frame: frame
        });
        const sprite = new $iuB9z.Sprite(texture);
        sprite.x = -250;
        sprite.y = -250;
        sprite.anchor.set(.5);
        return this.addChild(sprite);
    }
}



var $gix9M = parcelRequire("gix9M");

const $a2205943464b2a39$var$header = "Cat Mode";
const $a2205943464b2a39$var$handleFunc = (isActive)=>(0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).emit((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).catMode, isActive);
const $a2205943464b2a39$var$coords = {
    horizontal: {
        x: 120,
        y: 320
    },
    vertical: {
        x: -220,
        y: 630
    }
};
class $a2205943464b2a39$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: $a2205943464b2a39$var$header,
            coords: $a2205943464b2a39$var$coords,
            handleFunc: $a2205943464b2a39$var$handleFunc
        });
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).showSecondAngles, (v)=>this.setActivation(v));
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).segmentMode, (v)=>this.setActivation(v));
    }
}



var $gix9M = parcelRequire("gix9M");

const $44af85fa86497661$var$header = "Second Angle";
const $44af85fa86497661$var$handleFunc = (isActive)=>(0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).emit((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).showSecondAngles, isActive);
const $44af85fa86497661$var$coords = {
    horizontal: {
        x: 120,
        y: 250
    },
    vertical: {
        x: 230,
        y: 630
    }
};
class $44af85fa86497661$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: $44af85fa86497661$var$header,
            coords: $44af85fa86497661$var$coords,
            handleFunc: $44af85fa86497661$var$handleFunc
        });
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).catMode, (v)=>this.setActivation(v));
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).segmentMode, (v)=>this.setActivation(v));
    }
}



var $jtirH = parcelRequire("jtirH");

function $5d0b0198f506f7db$export$2e2bcd8739ae039(circle, radians, isBtws, isShownSecondAngles) {
    let r = radians;
    let ArcColors = [
        ...(0, $14419ed3de2cf7a8$export$bdea539c223eec51)
    ];
    !isShownSecondAngles && (ArcColors[0] = 0x000000);
    if (isBtws[0] && isBtws[1]) circle.setColors(ArcColors);
    else if (!isBtws[0] && !isBtws[1]) {
        circle.setColors(ArcColors);
        r = [
            radians[1],
            radians[0],
            radians[3],
            radians[2]
        ];
    } else circle.setColors(Array(4).fill(0x000000));
    return r;
}



var $jISXQ = parcelRequire("jISXQ");



var $9tAmQ = parcelRequire("9tAmQ");

var $gix9M = parcelRequire("gix9M");

class $2c12c3628ed453ab$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: "Segment Mode",
            coords: {
                vertical: {
                    x: 0,
                    y: 630
                },
                horizontal: {
                    x: 120,
                    y: 390
                }
            },
            handleFunc: (v)=>(0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).emit((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).segmentMode, v)
        });
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).catMode, (v)=>this.setActivation(v));
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).showSecondAngles, (v)=>this.setActivation(v));
    }
}


class $c1a4381a90ae59e5$export$2e2bcd8739ae039 extends (0, $9tAmQ.default) {
    constructor(cCoord){
        super(cCoord);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).segmentMode, (v)=>this.handleSegmentVisible(v));
        new (0, $2c12c3628ed453ab$export$2e2bcd8739ae039)();
    }
}


class $be06b57d1faab6d3$export$2e2bcd8739ae039 {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    circleRadius = (0, $14419ed3de2cf7a8$export$ca8f2c484d507a5d);
    cCoord = (0, $jISXQ.default)(this.Game.getDim(), (0, $14419ed3de2cf7a8$export$c7609d9da8d80867));
    SliderManager = new (0, $ee97e2cbc2d5cb1e$export$2e2bcd8739ae039)();
    PointManager = new (0, $30d9f05454be34d0$export$2e2bcd8739ae039)(this.cCoord);
    PointTagManager = new (0, $126c660212978562$export$2e2bcd8739ae039)(this.cCoord);
    LineManager = new (0, $9d8e089194180c48$export$2e2bcd8739ae039)();
    InfoSlider = new (0, $fGH3X.default)((0, $14419ed3de2cf7a8$export$840ec2322406bfdd));
    AngleManager = new (0, $0749e5568c1feeec$export$2e2bcd8739ae039)();
    circle = new (0, $iiVV4.default)(this.cCoord, (0, $14419ed3de2cf7a8$export$95c476c8e1b0007), (0, $14419ed3de2cf7a8$export$bdea539c223eec51));
    CircleAnimationManager;
    cat = new (0, $507e03cfb66f43c9$export$2e2bcd8739ae039)(this.cCoord);
    catModeSwitcherCon = new (0, $a2205943464b2a39$export$2e2bcd8739ae039)();
    secondAngleSwitcherCon = new (0, $44af85fa86497661$export$2e2bcd8739ae039)();
    SegmentChord = new (0, $c1a4381a90ae59e5$export$2e2bcd8739ae039)(this.cCoord);
    isShownSecondAngles = false;
    constructor(){
        if (!$be06b57d1faab6d3$export$2e2bcd8739ae039.instance) $be06b57d1faab6d3$export$2e2bcd8739ae039.instance = this;
        new (0, $3DpJv.default)();
        this.CircleAnimationManager = new (0, $676471eec30405b5$export$2e2bcd8739ae039)(this.PointManager, this.PointTagManager, this.AngleManager, this.LineManager, this.circle, this.cCoord);
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, this.cCoord);
        (0, $7ca2578c40a9e88e$export$f6644f0f2c90144b).on((0, $7ca2578c40a9e88e$export$cb883390c27ec6dd).showSecondAngles, (v)=>this.setShowSecondAngles(v));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.drawElements());
        this.drawElements();
    }
    static getInstance = ()=>$be06b57d1faab6d3$export$2e2bcd8739ae039.instance;
    setShowSecondAngles(v) {
        this.isShownSecondAngles = v;
        this.drawElements();
    }
    drawElements() {
        const radians = this.PointManager.getRadians();
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        const isBtwA = (0, $jtirH.default)(this.cCoord, redPointsCoord[0], radians[3], radians[2]);
        const isBtwB = (0, $jtirH.default)(this.cCoord, redPointsCoord[1], radians[3], radians[2]);
        const r = (0, $5d0b0198f506f7db$export$2e2bcd8739ae039)(this.circle, radians, [
            isBtwA,
            isBtwB
        ], this.isShownSecondAngles);
        this.circle.draw({
            radians: r,
            radius: this.circleRadius
        });
        this.PointTagManager.updateCoord(radians, this.circleRadius);
        this.LineManager.draw(redPointsCoord);
        this.AngleManager.draw(redPointsCoord, [
            isBtwA,
            isBtwB
        ], this.isShownSecondAngles);
        this.SegmentChord.draw((0, $14419ed3de2cf7a8$export$ca8f2c484d507a5d), [
            radians[2],
            radians[3]
        ], [
            redPointsCoord[2],
            redPointsCoord[3]
        ], isBtwA || isBtwB);
        this.cat.updateCoord(radians);
    }
}



const $eebea41eb6bf4476$var$canvas = document.querySelector("#canvas");
if ($eebea41eb6bf4476$var$canvas) window.context = new (0, $75RpY.default)($eebea41eb6bf4476$var$canvas, (0, $14419ed3de2cf7a8$export$2e51dc0dfab2d766), ()=>new (0, $be06b57d1faab6d3$export$2e2bcd8739ae039)(), [
    (0, $14419ed3de2cf7a8$export$6e9eb14a7bc3c2c7)
]);
else console.error("Canvas is not found");


//# sourceMappingURL=index.3c03bf31.js.map
